class SurfstrHeader {
  #root;
  #toggle;
  #panel;
  #openLabel;
  #closeLabel;

  constructor(root) {
    this.#root = root;
    this.#toggle = root.querySelector('[data-surfstr-menu-toggle]');
    this.#panel = root.querySelector('[data-surfstr-mobile-nav]');
    if (!this.#toggle || !this.#panel) return;

    this.#openLabel = root.dataset.menuOpenLabel ?? 'Open menu';
    this.#closeLabel = root.dataset.menuCloseLabel ?? 'Close menu';

    this.#toggle.addEventListener('click', () => this.#handleToggle());
    this.#panel.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => this.#setOpen(false));
    });
    window.addEventListener('scroll', () => this.#handleScroll(), { passive: true });
    window.addEventListener('keydown', (event) => this.#handleKeydown(event));
    this.#handleScroll();
  }

  #handleKeydown(event) {
    if (event.key !== 'Escape') return;
    if (this.#toggle.getAttribute('aria-expanded') !== 'true') return;
    this.#setOpen(false);
    this.#toggle.focus();
  }

  #handleScroll() {
    this.#root.classList.toggle('surfstr-header--scrolled', window.scrollY > 48)
  }

  #handleToggle() {
    const isOpen = this.#toggle.getAttribute('aria-expanded') === 'true';
    this.#setOpen(!isOpen);
  }

  #setOpen(open) {
    this.#toggle.setAttribute('aria-expanded', String(open));
    this.#panel.hidden = !open;
    this.#root.classList.toggle('surfstr-header--open', open);
    document.body.classList.toggle('surfstr-nav-open', open);
    const label = this.#toggle.querySelector('.visually-hidden');
    if (label) label.textContent = open ? this.#closeLabel : this.#openLabel;
  }
}

document.querySelectorAll('[data-surfstr-header]').forEach((el) => new SurfstrHeader(el));
